import { makeAutoObservable } from 'mobx';
import { QuestionState } from '../../../constans/question-enums';

type IStatusLabels = {
  [key in QuestionState | string]?: number;
}

class ManageQuestionsNewLabel {
  private numberOfNewQuestions: IStatusLabels;
  private additionalIndex: number;
  private zeroIndex: number;

  constructor () {
    makeAutoObservable(this);
    this.init();
  }

  private init () {
    this.numberOfNewQuestions = {};
    this.additionalIndex = 1;
    this.zeroIndex = 0;
  }

  public increment (key: QuestionState | string): void {
    if(!this.numberOfNewQuestions[key]) {
      this.numberOfNewQuestions[key] = this.zeroIndex;
    }
    this.numberOfNewQuestions[key] = this.numberOfNewQuestions[key]! + this.additionalIndex;
  }

  public decrement (key: QuestionState | string): void {
    if(!this.numberOfNewQuestions[key]) return;

    this.numberOfNewQuestions[key] = this.numberOfNewQuestions[key]! - this.additionalIndex;

    if(this.numberOfNewQuestions[key]! < this.zeroIndex) {
      this.numberOfNewQuestions[key] = this.zeroIndex;
    }
  }

  public onSubscribeNewQuestionStatus (key: QuestionState | string): number {
    return this.numberOfNewQuestions[key] || this.zeroIndex;
  }
}

export { ManageQuestionsNewLabel };